import { useCreateRecipientGroup } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.ADD_RECIPIENT_GROUP';

type UseAddRecipientGroupArgsType = {
  venueId: string;
};

type UseAddRecipientGroupReturnType = {
  // Resolves to true on success so the caller only closes the modal then.
  addRecipientGroup: (label: string) => Promise<boolean>;
};

// The groups refetch is triggered by the generated mutation (see orval.config.ts).
export const useAddRecipientGroup = ({
  venueId,
}: UseAddRecipientGroupArgsType): UseAddRecipientGroupReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync } = useCreateRecipientGroup<AxiosError>();

  const addRecipientGroup = async (label: string) => {
    try {
      await mutateAsync({ data: { label }, params: { venueId } });
    } catch (error) {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error: error as AxiosError,
      });
      return false;
    }

    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
    return true;
  };

  return { addRecipientGroup };
};
